<template>
  <div class="sub-menu-coming-soon sub-menu-details sub-menu">
    <p
      class="
        text-desktop-regular-desktop
        text-mobile-regular-mobile
        sub-menu-coming-soon__text
      "
      v-text="content?.comingSoon?.text"
    />

    <!-- Upper bullet list -->
    <div
      v-if="content?.comingSoon?.bullets?.length"
      class="sub-menu-details__bullets rte"
    >
      <ul class="sub-menu-details__bullets-list">
        <li
          v-for="(bullet, index) of content.comingSoon.bullets"
          :key="`sub-menu-details-bullet-${index}`"
          class="
            text-desktop-regular-desktop
            text-mobile-regular-mobile
            sub-menu-details__bullets-item
          "
          v-text="bullet"
        />
      </ul>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu coming-soon
 * -----------------------------------------------------------------------------
 * Coming soon sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 */
export default {
  name: 'SubMenuComingSoon',

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
